'use client'

import { XMarkIcon } from '@heroicons/react/24/outline'
import { useIsScreenWidthBelow } from '@tebuto/functions/responsiveness'
import Image from 'next/image'
import { useState } from 'react'

interface IFullScreenImage {
    src: string
    mobileSrc?: string
    alt: string
    width: number
    height: number
    className?: string
    mobileClassName?: string
    mobileBreakPoint?: number // 768 == MD breakpoint
}

const FullScreenImage = ({
    src,
    mobileSrc,
    alt,
    width,
    height,
    className = '',
    mobileClassName,
    mobileBreakPoint = 768
}: IFullScreenImage) => {
    const [isFullscreen, setIsFullscreen] = useState(false)
    const isMobile = useIsScreenWidthBelow(mobileBreakPoint)

    const toggleFullscreen = () => {
        setIsFullscreen(!isFullscreen)
    }

    return (
        <>
            {/* The thumbnail or regular sized image */}
            <div onClick={toggleFullscreen}>
                <Image
                    src={isMobile && mobileSrc ? mobileSrc : src}
                    alt={alt}
                    width={width}
                    height={height}
                    // Apply mobile css if isMobile is true and mobileClassName is provided
                    // Otherwise, apply the regular className
                    // Always apply className if not mobile
                    className={`${isMobile ? '' : 'cursor-zoom-in'} ${isMobile && mobileClassName ? mobileClassName : className}`}
                />
            </div>

            {/* Fullscreen overlay */}
            {isFullscreen && !isMobile && (
                <div
                    className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 cursor-zoom-out"
                    onClick={toggleFullscreen}
                >
                    <div className="relative w-full h-full md:w-[90vw] md:h-[90vh]">
                        {/* Fullscreen image */}
                        <Image src={src} alt={alt} fill sizes="100vw" className="object-contain" />
                    </div>

                    {/* Close button */}
                    <button type="button" onClick={toggleFullscreen} className="absolute top-4 right-4 text-white">
                        <XMarkIcon className="h-8 w-8" />
                    </button>
                </div>
            )}
        </>
    )
}

export default FullScreenImage
